import { render, staticRenderFns } from "./AddInvoiceItemComponent.vue?vue&type=template&id=17158b29&"
import script from "./AddInvoiceItemComponent.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports